import css from "./SinglePage.sass?inline"
import {Html} from "@opendaw/lib-dom"
import {isDefined} from "@opendaw/lib-std"
import {createElement, PageContext, PageFactory} from "@opendaw/lib-jsx"
import {CardView} from "@/CardView"
import {TracksList} from "@/api"

const className = Html.adoptStyleSheet(css, "SinglePage")

export const SinglePage: PageFactory<TracksList> = ({path, service}: PageContext<TracksList>) => {
    const id = path.substring(path.lastIndexOf("/") + 1)
    const track = service.tracks.find(track => track.id === id)
    return (
        <div className={className}>
            {isDefined(track) ? <CardView track={track}/> : <h2>{`Track with id: ${id} not found.`}</h2>}
            <a href="/">Browse more...</a>
        </div>
    )
}